import request from '@/utils/request'

const feedback = {
  name: 'feedback',
  state: {
    isFeedbackDetailLoading: false,
    feedbackDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_FEEDBACK_DETAIL_LOADING: (state, data) => {
      state.isFeedbackDetailLoading = data
    },
    SET_MODULES_FEEDBACK_DETAIL_DATA: (state, data) => {
      state.feedbackDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryFeedbackDetailData({ commit }, id) {
      commit('SET_IS_MODULES_FEEDBACK_DETAIL_LOADING', true)
      commit('SET_MODULES_FEEDBACK_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/feedback/feedbackDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_FEEDBACK_DETAIL_LOADING', false)
          commit('SET_MODULES_FEEDBACK_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_FEEDBACK_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetFeedbackDetailData({ commit }) {
      commit('SET_MODULES_FEEDBACK_DETAIL_DATA', {})
    },
    setFeedbackDetailData({ commit }, data) {
      commit('SET_MODULES_FEEDBACK_DETAIL_DATA', data)
    }
  }
}

export default feedback
